const handleChange = (setter) => (e) => {
    const { name, value } = e.target;
    setter((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  
  export default handleChange;
  